// action - account reducer
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_PUNCTUATIONS = 'UPDATE_PUNCTUATIONS';
export const UPDATE_TEXT_TO_NUMBERS = 'UPDATE_TEXT_TO_NUMBERS';
